import StrateSliderTemoignages from './acf_blocks/strate-slider-temoignages';
import StrateEquipe3Etapes from './acf_blocks/strate-equipe-3-etapes';
import Strate4TinyBlocksRow from './acf_blocks/strate-4-tiny-blocks-row';
import StratePushFaq from './acf_blocks/strate-push-faq';
import StrateFaq from './acf_blocks/strate-faq';
import StrateComparaisonFormule from './acf_blocks/strate-comparaison-formules';
import strateOngletsTemoignage from './acf_blocks/strate-onglets-temoignage';
import initStrateArchiveBlog from './acf_blocks/strate-archive-blog';
import StratePricing3Col from './acf_blocks/strate-pricing-3-col';
import StrateOffresConnecteursClesEnMain from './acf_blocks/strate-offres-connecteurs-cles-en-main';
import initHubspotMultistepForms from './acf_blocks/hubspot-multistep-form';
import strateSolutionGestionInterventions from './acf_blocks/strate-solution-gestion-interventions';
import headerCarriere from './acf_blocks/header-carriere';
import strateMaillageBlogGuide from './acf_blocks/strate-maillage-blog-guide';
import strateIntroCsm from './acf_blocks/strate-intro-csm';
import StratePraxedoInternational from './acf_blocks/strate-praxedo-international';
import StrateHappyAtWork from './acf_blocks/strate-happy-at-work.js';
import StrateMaillageBlogGuideCards from './acf_blocks/strate-maillage-blog-guide-cards.js';
import strateOffresEmplois from './acf_blocks/strate-offres-emplois.js';
import StratePartenaires from './acf_blocks/strate-partenaires';
import StrateNouveauSliderTemoignages from './acf_blocks/strate-nouveau-slider-temoignages';
import Economie from './acf_blocks/calculette-economie';
import Turnover from './acf_blocks/calculette-turnover';
import StrateAddons from "./acf_blocks/strate-addons";

import FaqAccordeon from './faq-accordeon';
import ClassicAccordion from './classic-accordion';
import PopinVideo from './popin_video';
import initHeader from './header';
import Footer from './footer';
import Menu from './menu';
import Carousel from './carousel';
import AnchorBehavior from './anchor_behavior';
import initSelectResize from './select-resize';
import LoadBanner from './load-banner';
import BannerNews from "./banner-news";
import Sommaire from "./sommaire";

initHeader();
LoadBanner.init();
BannerNews.init();
StrateSliderTemoignages.init();
StrateEquipe3Etapes.init();
PopinVideo.init();
Strate4TinyBlocksRow.init();
StrateFaq.init();
StratePushFaq.init();
strateOngletsTemoignage.init();
StrateComparaisonFormule.init();
StratePricing3Col.init();
StrateOffresConnecteursClesEnMain.init();
initStrateArchiveBlog();
initHubspotMultistepForms();
FaqAccordeon.init();
ClassicAccordion.init();
strateSolutionGestionInterventions.init();
headerCarriere.init();
Menu.init();
AnchorBehavior.init();
strateMaillageBlogGuide.init();
initSelectResize();
Footer.init();
Carousel.init();
strateIntroCsm.init();
StratePraxedoInternational.init();
StrateHappyAtWork.init();
StrateMaillageBlogGuideCards.init();
strateOffresEmplois.init();
StratePartenaires.init();
StrateNouveauSliderTemoignages.init();
Economie.init();
Turnover.init();
StrateAddons.init();
Sommaire.init();
